export function stripAccents(value) {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function foldForSearch(value) {
    return stripAccents(value).toLowerCase();
}
// Every typed word must appear, so a full name matches in either order.
export function matchesEveryWord(value, search) {
    const foldedValue = foldForSearch(value);
    return foldForSearch(search)
        .split(/\s+/)
        .every((word) => foldedValue.includes(word));
}
export function joinOptional(strings, separator = ' ') {
    return strings.filter(Boolean).join(separator);
}
